export type Icon = {
    title: string;
    name: string;
    hasDarkMode?: boolean;
    dataImage?: string;
    size?: { height: string; width: string };
};

export const icons = {
    close: {
        title: "Close",
        name: "close-x",
    },
    event: {
        title: "Event Icon",
        name: "objects--events",
    },
    location: {
        title: "Location Icon",
        name: "objects--locations",
    },
    organization: {
        title: "Organization Icon",
        name: "objects--organizations",
        hasDarkMode: true,
    },
    resource: {
        title: "Resource Icon",
        name: "objects--resources",
    },
    task: {
        title: "Task Icon",
        name: "objects--tasks",
    },
    contact: {
        title: "Contact Icon",
        name: "objects--contacts",
    },
    contactFilled: {
        title: "Contact",
        name: "objects--contact-filled",
    },
    help: {
        title: "Help",
        name: "help",
    },
    info: {
        title: "Info",
        name: "info",
    },
    chevronUp: {
        title: "Chevron Up",
        name: "chevron-up",
    },
    chevronDown: {
        title: "Chevron Drown",
        name: "chevron-down",
    },
    arrowDown: {
        title: "Arrow Down",
        name: "arrow--down",
    },
    arrowUp: {
        title: "Arrow Up",
        name: "arrow--up",
    },
    arrowLeft: {
        title: "Arrow Left",
        name: "arrow--left",
    },
    arrowRight: {
        title: "Arrow Right",
        name: "arrow--right",
    },
    arrowRightDown: {
        title: "Arrow Right Down",
        name: "arrow--right-down",
    },
    arrowSelect: {
        title: "Select",
        name: "arrow--up-down",
    },
    star: {
        title: "Star",
        name: "star",
    },
    pen: {
        title: "Edit",
        name: "pen",
        dataImage: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAURJREFUeNpidOi/85+BCLC/QJkRRM+bPAGsPim3AMxnBBkAlMSr+ecfBob7Z9YwrNt6kiFa3Qgstvf9S7AhTMTYDtMsISaNIt5WW/qfoAE3Tqxh+He7kSHI2xzMX3rzHNj2F6+egg1kwudsmGaVwAUMSjqKDBYCc8FyIM2wcGDB52yYZhC4sz6B4efVawyeDNcY5r02Zpg89xQ4EFlgthGjGRwLSJpBgIlYm7FpxjCAkOYp8/5heBXFgGOnn4A1/+cwZrh35T5cHKS5Z+YprGEFDoNXXxECbDzG4NBH1lzWdwpFDU4XgKInN9kM7poNtzwYDA2i8KYTFAMmzb4IpkGpDpZQrExlgLb/B2OcXoB44z9DW7UXPJHANH+VC8brAhaYZhDQD85n0EeS/EpEPmEUF3clmJ1fvnwHZ///fwYlHQAEGAByQ7RHbTw62wAAAABJRU5ErkJggg==`,
        size: { height: "16px", width: "16px" },
    },
    plus: {
        title: "Add",
        name: "plus",
    },
    edit: {
        title: "Edit",
        name: "edit",
    },
    cog: {
        title: "Settings",
        name: "settings--cog",
    },
    refresh: {
        title: "Refresh",
        name: "refresh",
    },
    caretUp: {
        title: "Up",
        name: "caret--caret-up",
    },
    caretDown: {
        title: "Down",
        name: "caret--caret-down",
    },
    caretRight: {
        title: "Right",
        name: "caret--caret-right",
    },
    dashboard: {
        title: "Dashboard",
        name: "dashboard",
    },
    dragHandle: {
        title: "Drag",
        name: "drag--indicator",
    },
    check: {
        title: "Check",
        name: "check",
    },
    collapse: {
        title: "Collapse",
        name: "collapse",
    },
    expand: {
        title: "Expand",
        name: "expand",
    },
    warningYield: {
        title: "Warning",
        name: "warnings--yield",
    },
    doubleArrowRight: {
        title: "Double Arrow Right",
        name: "arrow--right-double",
    },
    doubleArrowLeft: {
        title: "Double Arrow Left",
        name: "arrow--left-double",
    },
    no: {
        title: "No",
        name: "no",
    },
    merge: {
        title: "Merge",
        name: "arrow--merge",
    },
    blackout: {
        title: "Blackout",
        name: "blackout",
    },
    calendarCalendar: {
        title: "Calendar",
        name: "calendar--calendar",
    },
    calendarCalendarX: {
        title: "Calendar X",
        name: "calendar--calendar-x",
    },
    calendarDate: {
        title: "Calendar Date",
        name: "calendar--calendar-date",
    },
    calendarDateRounded: {
        title: "Calendar Date",
        name: "calendar--calendar-date--round",
    },
    camera: {
        title: "Camera",
        name: "camera",
    },
    caretLeft: {
        title: "Caret Left",
        name: "caret--caret-left",
    },
    clock: {
        title: "Clock",
        name: "clock",
    },
    dataImport: {
        title: "Data Import",
        name: "components--data_import",
    },
    groupsAdmin: {
        title: "Groups Admin",
        name: "components--groups_admin",
    },
    guestView: {
        title: "Guest View",
        name: "components--guest_view",
    },
    lynxInterface: {
        title: "Lynx Interface",
        name: "components--lynx_interface",
    },
    pricing: {
        title: "Pricing",
        name: "components--pricing",
    },
    publisher: {
        title: "Publisher",
        name: "components--publisher",
    },
    reports: {
        title: "Reports",
        name: "components--reports",
    },
    optimizer: {
        title: "Optimizer",
        name: "components--schedule25_optimizer",
    },
    scheduling: {
        title: "Scheduling",
        name: "components--scheduling",
    },
    schedulingAdvanced: {
        title: "Calendar",
        name: "components--scheduling-advanced",
    },
    systemAdmin: {
        title: "System Admin",
        name: "components--system_admin",
    },
    x25Analytics: {
        title: "x25 Analytics",
        name: "components--x25_analytics",
    },
    copy: {
        title: "Copy",
        name: "copy",
    },
    diagram: {
        title: "Diagram",
        name: "diagram",
    },
    blank: {
        title: "Blank",
        name: "documents--blank",
    },
    draft: {
        title: "Draft",
        name: "documents--draft",
    },
    events: {
        title: "Event",
        name: "documents--event",
    },
    excel: {
        title: "Excel",
        name: "documents--excel",
    },
    html: {
        title: "HTML",
        name: "documents--html",
    },
    pdf: {
        title: "PDF",
        name: "documents--pdf",
    },
    text: {
        title: "Text",
        name: "documents--text",
    },
    image: {
        title: "Image",
        name: "documents--image",
    },
    x: {
        title: "X",
        name: "documents--x",
    },
    navEdit: {
        title: "Nav Edit",
        name: "navEdit",
    },
    ellipsis: {
        title: "Ellipsis",
        name: "ellipsis--ellipsis",
    },
    ellipsisVertical: {
        title: "Vertical Ellipsis",
        name: "ellipsis--ellipsis-vertical",
    },
    cabinet: {
        title: "Cabinet",
        name: "event_structure--cabinet",
    },
    cabinetOpen: {
        title: "Open Cabinet",
        name: "event_structure--cabinet-open",
    },
    chat: {
        title: "Chat",
        name: "chat",
    },
    folderDefault: {
        title: "Folder Default",
        name: "event_structure--folder-default",
    },
    folderImage: {
        title: "Folder Image",
        name: "event_structure--folder-image",
    },
    folderOpen: {
        title: "Folder Open",
        name: "event_structure--folder-open",
    },
    folderStack: {
        title: "Folder Stack",
        name: "event_structure--folder-stack",
    },
    flag: {
        title: "Flag",
        name: "flag--flag",
    },
    flagDown: {
        title: "Flag Down",
        name: "flag--flag-down",
    },
    grip: {
        title: "Grip",
        name: "grip",
    },
    home: {
        title: "Home",
        name: "home",
    },
    infinity: {
        title: "Infinity",
        name: "infinity",
    },
    key: {
        title: "Key",
        name: "key",
    },
    keyboard: {
        title: "Keyboard",
        name: "keyboard",
    },
    link: {
        title: "Link",
        name: "link--link",
    },
    instagram: {
        title: "Instagram",
        name: "instagram",
    },
    facebook: {
        title: "Facebook",
        name: "facebook",
    },
    linkedin: {
        title: "LinkedIn",
        name: "linkedin",
    },
    twitter: {
        title: "X (Twitter)",
        name: "twitter",
    },
    youtube: {
        title: "YouTube",
        name: "youtube",
    },
    tiktok: {
        title: "TikTok",
        name: "tiktok",
    },
    discord: {
        title: "Discord",
        name: "discord",
    },
    globe: {
        title: "Website",
        name: "globe",
    },
    linkBroken: {
        title: "Broken Link",
        name: "link--link-broken",
    },
    lock: {
        title: "Lock",
        name: "lock",
    },
    eyeOff: {
        title: "Hidden",
        name: "eye-off",
    },
    lockUnlocked: {
        title: "Unlocked Lock",
        name: "lock-unlocked",
    },
    mailCompose: {
        title: "Compose Email",
        name: "mail--compose",
    },
    mailMail: {
        title: "Mail",
        name: "mail--mail",
    },
    mailMailOpen: {
        title: "Open Mail",
        name: "mail--mail-open",
    },
    mailFilled: {
        title: "Mail",
        name: "mail--mail-filled",
    },
    mailSent: {
        title: "Sent Email",
        name: "mail--sent",
    },
    phone: {
        title: "Phone",
        name: "phone",
    },
    menu: {
        title: "Menu",
        name: "menu",
    },
    menuRightArrow: {
        title: "Menu Right",
        name: "menu--right-arrow",
    },
    minus: {
        title: "Minus",
        name: "minus",
    },
    ols: {
        title: "OLS",
        name: "object_level_security",
    },
    contactsCompound: {
        title: "Compound Contacts",
        name: "objects--contacts-compound",
    },
    drafts: {
        title: "Drafts",
        name: "objects--drafts",
    },
    eventsEdit: {
        title: "Edit Event",
        name: "objects--events-edit",
    },
    locationsCompound: {
        title: "Compound Locations",
        name: "objects--locations-compound",
    },
    locationMarker: {
        title: "Location Marker",
        name: "location-marker",
    },
    reportsObjects: {
        title: "Reports",
        name: "objects--reports",
    },
    taskCancelled: {
        title: "Cancelled Task",
        name: "objects--tasks-cancelled",
    },
    taskComplete: {
        title: "Completed Task",
        name: "objects--tasks-completed",
    },
    taskDefault: {
        title: "Task",
        name: "objects--tasks-default",
    },
    ownership: {
        title: "Ownership",
        name: "ownership",
    },
    pause: {
        title: "Pause",
        name: "pause",
    },
    pencil: {
        title: "Pencil",
        name: "pencil",
    },
    play: {
        title: "Play",
        name: "play",
    },
    print: {
        title: "Print",
        name: "print",
    },
    related: {
        title: "Related",
        name: "related",
    },
    rewind: {
        title: "Rewind",
        name: "rewind",
    },
    rss: {
        title: "RSS",
        name: "rss",
    },
    save: {
        title: "Save",
        name: "save",
    },
    search: {
        title: "Search",
        name: "search",
    },
    cogs: {
        title: "Cogs",
        name: "settings--cogs",
    },
    share: {
        title: "Share",
        name: "share",
    },
    share2: {
        title: "Share",
        name: "share-2",
    },
    signin: {
        title: "Sign In",
        name: "sign-in",
    },
    signout: {
        title: "Sign Out",
        name: "sign-out",
    },
    starFilled: {
        title: "Filled Star",
        name: "star--star-filled",
    },
    starOff: {
        title: "Star Off",
        name: "star--star-off",
    },
    starOn: {
        title: "Star On",
        name: "star--star-on",
    },
    stop: {
        title: "Stop",
        name: "stop--stop",
    },
    eventModule: {
        title: "Event Module",
        name: "system_admin--event_module",
    },
    eventStructure: {
        title: "Event Structure",
        name: "system_admin--event_structure",
    },
    masterDefinitions: {
        title: "Master Definitions",
        name: "system_admin--master_defintions",
    },
    systemPreferences: {
        title: "System Preferences",
        name: "system_admin--system_preferences",
    },
    thumbsDown: {
        title: "Thumbs Down",
        name: "thumbs--thumbs-down",
    },
    thumbsUp: {
        title: "Thumbs Up",
        name: "thumbs--thumbs-up",
    },
    trafficLight: {
        title: "Traffic Light",
        name: "traffic-light",
    },
    undo: {
        title: "Undo",
        name: "undo",
    },
    user: {
        title: "User",
        name: "user",
    },
    users: {
        title: "Users",
        name: "users",
    },
    warning: {
        title: "Warning",
        name: "warnings--warning",
    },
    edit2: {
        title: "Edit",
        name: "edit-2",
    },
    copy2: {
        title: "Copy",
        name: "copy-2",
    },
    calendar: {
        title: "calendar",
        name: "calendar",
    },
    share3: {
        title: "Share",
        name: "share-3",
    },
    clipboard: {
        title: "Clipboard",
        name: "clipboard",
    },
    printer: {
        title: "Printer",
        name: "printer",
    },
    mail: {
        title: "Mail",
        name: "mail",
    },
    trash2: {
        title: "Trash",
        name: "trash-2",
    },
    userCheck: {
        title: "User CHeck",
        name: "user-check",
    },
    userNew: {
        title: "New User",
        name: "user-new",
    },
    userPlus: {
        title: "Add User",
        name: "user-plus",
    },
    checkCircle: {
        title: "Check Circle",
        name: "check-circle",
    },
    dragIndicator: {
        title: "Drag Indicator",
        name: "drag--indicator",
    },
    inbox: {
        title: "Inbox",
        name: "inbox",
    },
    folderNew: {
        title: "New Folder",
        name: "folder--new",
    },
    fileNew: {
        title: "New File",
        name: "file--new",
    },
    alertCircle: {
        title: "Alert",
        name: "alert-circle",
    },
    alertTriangle: {
        title: "Alert Triangle",
        name: "alert-triangle",
    },
    powerPoint: {
        title: "Power Point",
        name: "powerPoint",
        dataImage: `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE0IDJINkM0Ljg5IDIgNCAyLjkgNCA0VjIwQzQgMjEuMTEgNC44OSAyMiA2IDIySDE4QzE5LjExIDIyIDIwIDIxLjExIDIwIDIwVjhMMTQgMk0xOCAyMEg2VjRIMTNWOUgxOFYyME0xNS4yIDEwLjhDMTQuNyAxMC4zIDE0LjEgMTAgMTIuOCAxMEg5VjE5SDEwLjZWMTUuN0gxMi44QzE0LjEgMTUuNyAxNC42IDE1LjUgMTUuMiAxNUMxNS44IDE0LjUgMTYgMTMuOCAxNiAxMi45QzE2IDEyIDE1LjggMTEuNCAxNS4yIDEwLjhNMTMuOSAxNEMxMy42IDE0LjMgMTMuMyAxNC41IDEyLjcgMTQuNUgxMC42VjExLjNIMTIuNkMxMy4yIDExLjMgMTMuNiAxMS41IDEzLjkgMTEuOEMxNC4yIDEyLjEgMTQuMyAxMi40IDE0LjMgMTIuOVMxNC4yIDEzLjcgMTMuOSAxNFoiIC8+PC9zdmc+`,
        size: { height: "1.5em", width: "1.5em" },
    },
    aiSparkles: {
        title: "Open AI Modal",
        name: "ai-sparkles",
    },
    queue: {
        title: "Queue",
        name: "queue",
    },
    workflow: {
        title: "Workflow",
        name: "workflow",
    },
    zoomIn: {
        title: "Zoom In",
        name: "zoom-in",
    },
    zoomOut: {
        title: "Zoom Out",
        name: "zoom-out",
    },
    magneticStripeCard: {
        title: "Magnetic Stripe Card",
        name: "magnetic-stripe-card",
    },
    layout: {
        title: "Layout",
        name: "layout",
    },
    bookmarkOutline: {
        title: "Bookmark",
        name: "bookmark--outline",
    },
    bookmarkHalfFilled: {
        title: "Bookmark (half filled)",
        name: "bookmark--half-filled",
    },
    bookmarkFilled: {
        title: "Bookmark (filled)",
        name: "bookmark--filled",
    },
    exit: {
        title: "Exit",
        name: "exit",
    },
    news: {
        title: "News",
        name: "news",
    },
    invoice: {
        title: "Invoice",
        name: "invoice",
    },
    paletteType: {
        title: "User Input",
        name: "palette--type",
    },
    paletteAlignLeft: {
        title: "Rich Text",
        name: "palette--align-left",
    },
    paletteClock: {
        title: "Duration",
        name: "palette--clock",
    },
    paletteUpload: {
        title: "File Upload",
        name: "palette--upload",
    },
    paletteImage: {
        title: "Image",
        name: "palette--image",
    },
    paletteChevronDown: {
        title: "Select",
        name: "chevron-down",
    },
    paletteListChecks: {
        title: "Multi-Select",
        name: "palette--list-checks",
    },
    paletteSquareCheck: {
        title: "Checkbox",
        name: "palette--square-check",
    },
    paletteCircleDot: {
        title: "Radio Button",
        name: "palette--circle-dot",
    },
    paletteToggleRight: {
        title: "Toggle",
        name: "palette--toggle-right",
    },
    paletteStar: {
        title: "Stars Rating",
        name: "palette--star",
    },
    paletteNumericScale: {
        title: "Numeric Scale",
        name: "palette--bar-chart-2",
    },
    paletteSectionHeader: {
        title: "Section Header",
        name: "palette--heading-1",
    },
    paletteOrganization: {
        title: "Organization",
        name: "palette--building-2",
    },
    paletteUserSearch: {
        title: "Contact",
        name: "palette--user-search",
    },
    paletteCalendarSearch: {
        title: "Event",
        name: "palette--calendar-search",
    },
    paletteUserCog: {
        title: "Org Role",
        name: "palette--user-cog",
    },
    paletteLayers: {
        title: "Organization Type",
        name: "palette--layers",
    },
    paletteActivity: {
        title: "Organization Rating",
        name: "palette--activity",
    },
    paletteFileText: {
        title: "Form",
        name: "palette--file-text",
    },
    paletteUsers: {
        title: "Registrants",
        name: "palette--users",
    },
    paletteCalendarCheck: {
        title: "Multiselect Occurrences",
        name: "palette--calendar-check",
    },
    paletteTag: {
        title: "Event Type",
        name: "palette--tag",
    },
    paletteCalendarClock: {
        title: "Occurrences",
        name: "palette--calendar-clock",
    },
    paletteTags: {
        title: "Event Categories",
        name: "palette--tags",
    },
    paletteSlidersHorizontal: {
        title: "Event Custom Attribute",
        name: "palette--sliders-horizontal",
    },
    paletteClipboardList: {
        title: "Event Requirements",
        name: "palette--clipboard-list",
    },
    paletteUserCheck: {
        title: "Event Contact Roles",
        name: "user-check",
    },
    paletteFolderOpen: {
        title: "Organization Categories",
        name: "palette--folder-open",
    },
    paletteWrench: {
        title: "Organization Custom Attribute",
        name: "palette--wrench",
    },
    paletteVote: {
        title: "Election Position",
        name: "palette--vote",
    },
    paletteExternalLink: {
        title: "25Live Event Form",
        name: "palette--external-link",
    },
} satisfies Record<string, Icon>;

export namespace S25Icons {
    export const typed = icons;
    export const untyped: { [name in Name]: Icon } = typed;

    export type Name = keyof typeof typed;
    export const names = <{ [name in Name]: name }>Object.fromEntries(Object.keys(icons).map((name) => [name, name]));
    export const titles = <{ [name in Name]: (typeof typed)[name]["title"] }>(
        Object.fromEntries(Object.entries(icons).map(([key, value]) => [key, value.title]))
    );
}
